/* ETQ — makes tagged banner sections fully clickable. */
(function () {
  function bind() {
    document.querySelectorAll('[data-etq-banner-link]').forEach(function (el) {
      if (el.dataset.etqBannerBound) return;
      el.dataset.etqBannerBound = '1';

      var url = el.getAttribute('data-etq-banner-link');
      if (!url) return;

      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        window.location.href = url;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  window.addEventListener('load', bind);
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', bind);
  }
})();